import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Switch,
  Stack,
  Paper,
  alpha,
  Divider,
  CircularProgress,
} from '@mui/material';
import { message } from 'antd'; // Keeping antd message for consistent error/success toast
import LoadingContent from '../../../components/common/LoadingContent';
import { getNotifications, disableNotification, enableNotification } from '../../../helpers/api';
import { openNotification } from '../../../helpers/notification';
import './style.css';

const NotificationForm = () => {
  const [notifications, setNotifications] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    refreshNotifications();
  }, []);

  useEffect(() => {
    if (reload) {
      refreshNotifications();
    }
  }, [reload]);

  const refreshNotifications = () => {
    setLoading(true);
    getNotifications()
      .then((res) => {
        setNotifications(res.result.data);
        setReload(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        return openNotification({
          type: 'error',
          title: 'Something went wrong',
          message: error,
        });
      });
  };

  const reloadNotifications = () => {
    setReload(true);
  };

  const handleToggle = (checked, settingsName) => {
    const apiCall = checked ? enableNotification : disableNotification;

    apiCall(settingsName)
      .then(() => {
        console.log('updated');
      })
      .catch((error) => {
        console.log(error);
        message.error(error?.message || error);
        reloadNotifications();
      });
  };

  const displayNotification = () => {
    if (notifications && notifications.length > 0) {
      return notifications.map((notif, index) => (
        <Paper
          key={index}
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: '16px',
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: alpha('#F4F6F8', 0.2),
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle1" fontWeight={700} color="text.primary">
              {notif.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {notif.subTitle}
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Stack spacing={2}>
            {notif.content.map((content, idx) => (
              <Stack
                key={idx}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  p: 1.5,
                  borderRadius: '10px',
                  bgcolor: '#fff',
                  border: '1px solid',
                  borderColor: alpha('#000', 0.05),
                }}
              >
                <Typography variant="body2" fontWeight={500} color="text.primary">
                  {content.settingDesc}
                </Typography>

                <Switch
                  size="small"
                  defaultChecked={content.settingsValue === 'true'}
                  onChange={(e) => handleToggle(e.target.checked, content.settingsName)}
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'primary.main',
                    },
                  }}
                />
              </Stack>
            ))}
          </Stack>
        </Paper>
      ));
    } else {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
          <CircularProgress size={24} />
        </Box>
      );
    }
  };

  return (
    <Box className="notification__form" sx={{ mb: 4 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
        displayNotification()
      )}
    </Box>
  );
};

export default NotificationForm;
